


const Spinner = () => {
    return (
        <div style={{paddingTop:"10rem"}} className="text-center    ">
            <div style={{height:"4rem" , width:"4rem"}} className="spinner-border text-primary a mt-5 spinner" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        </div>
      );
    };
export default Spinner